export default "/assets/images/mila-white-4.0f667718a76eca1c.png";